// The types of actions that you can dispatch to modify the state of the store

export const SIGNOUT = 'SIGNOUT';
export const SET_USERS = 'SET_USERS';
export const DELETE_USER = 'DELETE_USER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_ROLES = 'SET_ROLES';
export const PASSWORD_VERIFY_SUCCESS = 'PASSWORD_VERIFY_SUCCESS';
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const UNSET_CURRENT_USER = 'UNSET_CURRENT_USER';
export const SET_ERRORS = 'SET_ERRORS';
export const DELETE_ERROR_FOR_INPUT = 'DELETE_ERROR_FOR_INPUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_ATTACHMENT = 'SET_ATTACHMENT';
export const SET_DONORS = 'SET_DONORS';
export const SET_SELECTED_DONOR = 'SET_SELECTED_DONOR';
export const SET_ASSET = 'SET_ASSET';
export const RESET_ASSETS = 'RESET_ASSETS';
export const RESET_ATTACHMENTS = 'RESET_ATTACHMENTS';
export const UNSET_ATTACHMENTS = 'UNSET_ATTACHMENTS';
export const UNSET_PROJECT = 'UNSET_PROJECT';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const UNSET_ASSET = 'UNSET_ASSET';
export const UPDATE_ASSET = 'UPDATE_ASSET';
export const UPDATE_ATTACHMENT = 'UPDATE_ATTACHMENT';
export const SET_USER_TIMESHEETS = 'SET_USER_TIMESHEETS';
export const SET_COMPANY_TIMESHEETS = 'SET_COMPANY_TIMESHEETS';
export const SET_LEAVES = 'SET_LEAVES';
export const UNSET_SELECTED_PROJECT = 'UNSET_SELECTED_PROJECT';
export const PASSWORD_RESET_RES = 'PASSWORD_RESET_RES';

export const SET_DOCUMENTS = 'SET_DOCUMENTS';
export const SET_SELECTED_DOCUMENT = 'SET_SELECTED_DOCUMENT';

export const SET_LETTERS = 'SET_LETTERS';
export const SET_SELECTED_LETTER = 'SET_SELECTED_LETTER';
export const SET_LETTER_TEMPLATES = 'SET_LETTER_TEMPLATES';
export const SET_SELECTED_LETTER_TEMPLATE = 'SET_SELECTED_LETTER_TEMPLATE';

export const SET_ONLINE_USERS = 'SET_ONLINE_USERS';

export const USER_GET_MY_ID = 'USER_GET_MY_ID';

export const CONTACT_SET_MY_ID = 'CONTACT_SET_MY_ID';

export const CONTACT_WINDOW_MAXIMIZE = 'CONTACT_WINDOW_MAXIMIZE';
export const CONTACT_WINDOW_MINIMIZE = 'CONTACT_WINDOW_MINIMIZE';
export const CONTACT_MODAL_BLINK = 'CONTACT_MODAL_BLINK';
export const CONTACTS_GET = 'CONTACTS_GET';
export const CONTACT_MODAL_OPEN = 'CONTACT_MODAL_OPEN';
export const CONTACT_MODAL_CLOSE = 'CONTACT_MODAL_CLOSE';
export const CONTACT_MODAL_HIDE = 'CONTACT_MODAL_HIDE';
export const CONTACT_MODAL_UNHIDE = 'CONTACT_MODAL_UNHIDE';
export const CONTACT_SWITCH_TO_HIDDEN = 'CONTACT_SWITCH_TO_HIDDEN';

export const MESSAGES_REQUEST = 'MESSAGES_REQUEST';
export const MESSAGES_ON_RECEIVE = 'MESSAGES_ON_RECEIVE';
export const MESSAGES_RECEIVED_UNREAD_COUNT = 'MESSAGES_RECEIVED_UNREAD_COUNT';
export const MESSAGE_ON_RECEIVE_NEW = 'MESSAGE_ON_RECEIVE_NEW';
export const MESSAGES_ON_MARK_READ = 'MESSAGES_ON_MARK_READ';
export const MESSAGES_ON_SEND = 'MESSAGES_ON_SEND';
export const MESSAGES_ON_SEEN = 'MESSAGES_ON_SEEN';
export const MESSAGES_FILE_REQUEST = 'MESSAGES_FILE_REQUEST';
export const MESSAGES_FILE_CANCEL = 'MESSAGES_FILE_CANCEL';

export const BUFF_RECEIVED = 'BUFF_RECEIVED';
export const ALL_FILES_RECEIVED = 'ALL_FILES_RECEIVED';

export const SET_USER_CALENDAR_ENTRIES = 'SET_USER_CALENDAR_ENTRIES';
export const SET_COMPANY_CALENDAR_ENTRIES = 'SET_COMPANY_CALENDAR_ENTRIES';

export const SET_FOLDERS = 'SET_FOLDERS';
export const SET_SELECTED_FOLDER = 'SET_SELECTED_FOLDER';


// WEBPACK FOOTER //
// ./src/actions/types.js